<template>
  <app-layout>
    <v-container fluid>
      <admin-conversation-detail
        v-if="$route.name === 'threadAdminDetail'"
      ></admin-conversation-detail>
      <admin-conversation-list v-else></admin-conversation-list>
    </v-container>
  </app-layout>
</template>

<script>
import AppLayout from '@/views/layouts/AppLayout.vue';
// import DashboardLayout from '@/views/layouts/DashboardLayout.vue';
// import MyConsultantConversation from '@/modules/myconsultant/components/threads/MyConsultantConversation.vue';
// import CalendarEvents from '@/modules/calendar/components/CalendarEvents.vue';
import AdminConversationDetail from '../components/AdminConversationDetail.vue';
import AdminConversationList from '../components/AdminConversationList';

export default {
  components: {
    AppLayout,
    // CalendarEvents,
    // MyConsultantConversation,
    // DashboardLayout,
    AdminConversationList,
    AdminConversationDetail,
  },

  data() {
    return {};
  },
  // Comment to avoid restoring filters when change of section/page
  // async mounted() {
  //   await this.restoreFilters();
  // },
  methods: {
    async restoreFilters() {
      await this.$store.dispatch('adminConv/resetParams');
    },
  },
};
</script>
